<form #form="ngForm" [formGroup]="userProfileForm" novalidate (ngSubmit)="save()" [ngClass]="{'form-field--unfilled form-field--readonly' : !isEditMode}" class="flex-col"  autocomplete="off">

  <div class="flex-row flex-col-ltmd gap-col-1em">
    <mat-form-field [floatLabel]="floatLabels" class="flex-1">
      <mat-label>{{'users.editor.FullName' | translate}}</mat-label>
      <input matInput formControlName="fullName" [readonly]="!isEditMode" />
    </mat-form-field>
    <mat-form-field [floatLabel]="floatLabels" class="flex-1">
      <mat-label>{{'users.editor.UserName' | translate}}</mat-label>
      <input matInput formControlName="userName" [readonly]="!isEditMode" autocomplete="off" />
      @if (userName.hasError('required')) {
        <mat-error>
          {{'users.editor.UserNameRequired' | translate}}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="flex-row flex-col-ltmd gap-col-1em">
    <mat-form-field [floatLabel]="floatLabels" class="flex-1">
      <mat-label>{{'users.editor.Email' | translate}}</mat-label>
      <input matInput formControlName="email" [readonly]="!isEditMode" />
      @if (email.hasError('required')) {
        <mat-error>
          {{'users.editor.EmailRequired' | translate}}
        </mat-error>
      }
      @if (!email.hasError('required') && email.hasError('email')) {
        <mat-error>
          {{'users.editor.InvalidEmail' | translate}}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field [floatLabel]="floatLabels" class="flex-1">
      <mat-label>{{'users.editor.PhoneNumber' | translate}}</mat-label>
      <input matInput formControlName="phoneNumber" [readonly]="!isEditMode" />
    </mat-form-field>
  </div>

  <div class="flex-row flex-col-ltmd gap-col-1em">
    @if ((isEditMode && !isNewUser && userName.value != user.userName) || (isChangePassword && isEditingSelf)) {
      <mat-form-field [floatLabel]="floatLabels" formGroupName="password" class="flex-1">
        <mat-label>{{'users.editor.CurrentPassword' | translate}}</mat-label>
        <input matInput type="password" formControlName="currentPassword" />
        @if (currentPassword.hasError('required')) {
          <mat-error>
            {{'users.editor.CurrentPasswordRequired' | translate}}
          </mat-error>
        }
      </mat-form-field>
    }
  </div>

  @if (isEditMode) {
    <div>
      @if (!(isChangePassword || isNewUser)) {
        <button mat-raised-button (click)="changePassword()" color="primary">{{'users.editor.ChangePassword' | translate}}</button>
      }
      @if (isChangePassword || isNewUser) {
        <div formGroupName="password" class="flex-row flex-col-ltmd gap-col-1em">
          <mat-form-field [floatLabel]="floatLabels" class="flex-1">
            <mat-label>{{'users.editor.NewPassword' | translate}}</mat-label>
            <input matInput type="password" formControlName="newPassword" autocomplete="off" />
            @if (newPassword.hasError('required')) {
              <mat-error>
                {{'users.editor.NewPasswordRequired' | translate}}
              </mat-error>
            }
            @if (!newPassword.hasError('required') && newPassword.hasError('pattern')) {
              <mat-error>
                {{'users.editor.NewPasswordRules' | translate}}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field [floatLabel]="floatLabels" class="flex-1">
            <mat-label>{{'users.editor.ConfirmPassword' | translate}}</mat-label>
            <input matInput type="password" formControlName="confirmPassword" />
            @if (confirmPassword.hasError('required')) {
              <mat-error>
                {{'users.editor.ConfirmationPasswordRequired' | translate}}
              </mat-error>
            }
            @if (!confirmPassword.hasError('required') && confirmPassword.hasError('notEqual')) {
              <mat-error>
                Test
                {{'users.editor.PasswordMismatch' | translate}}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
  }

  <div class="flex-row flex-col-ltmd gap-col-1em">

    <mat-form-field class="flex-1">
      <mat-label>{{'users.editor.Roles' | translate}}</mat-label>
      <mat-select formControlName="roles" multiple [disabled]="!isEditMode || !canAssignRoles">
        @for (role of assignableRoles; track role) {
          <mat-option [value]="role.name" [disabled]="checkRoleDisabled(role.name)" >
            <span matTooltip="{{role.description}}">{{role.name}}</span>
          </mat-option>
        }
      </mat-select>
      @if (assignedRoles.hasError('required')) {
        <mat-error>
          {{'users.editor.RoleRequired' | translate}}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="flex-1">
      <mat-label>Region</mat-label>
      <mat-select formControlName="regions" multiple [disabled]="!isEditMode">
        @for (entry of regions; track entry) {
          <mat-option [value]="entry.item1.toString()">
            {{ entry.item2 }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

  </div>

  <div class="flex-row flex-col-ltmd gap-col-1em">

    <div class="flex-nogrow50-gtsm">
      @if (isEditMode) {
        <mat-checkbox formControlName="isEnabled">{{'users.editor.Enabled' | translate}}</mat-checkbox>
      }
    </div>

    <div>
      @if (user.isLockedOut) {
        <button mat-button (click)="unlockUser()" [disabled]="isSaving" color="accent"><mat-icon class="mat-button-icon">lock_open</mat-icon>{{'users.editor.Unblock' | translate}}</button>
      }
    </div>
  </div>
</form>
